import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row justify-content-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("div", { class: "col-lg-6" }, [
      _createElementVNode("div", { class: "card bg-white border-0 rounded-3 mb-4" }, [
        _createElementVNode("div", { class: "card-body p-4" }, [
          _createElementVNode("h4", { class: "fs-18 mb-4" }, "Time Picker"),
          _createElementVNode("ul", {
            class: "nav nav-tabs mb-4",
            id: "myTab",
            role: "tablist"
          }, [
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link active",
                id: "preview-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#preview-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "preview-tab-pane",
                "aria-selected": "true"
              }, " Preview ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link",
                id: "code-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#code-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "code-tab-pane",
                "aria-selected": "false"
              }, " Code ")
            ])
          ]),
          _createElementVNode("div", {
            class: "tab-content",
            id: "myTabContent"
          }, [
            _createElementVNode("div", {
              class: "tab-pane fade show active",
              id: "preview-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "preview-tab",
              tabindex: "0"
            }, [
              _createElementVNode("div", { class: "form-group mb-0" }, [
                _createElementVNode("label", { class: "label" }, "Time Picker"),
                _createElementVNode("div", { class: "form-group position-relative" }, [
                  _createElementVNode("input", {
                    type: "time",
                    class: "form-control h-55 text-dark ps-5 h-58"
                  }),
                  _createElementVNode("i", { class: "ri-time-line position-absolute top-50 translate-middle-y fs-20 text-gray-light ps-20" })
                ])
              ])
            ]),
            _createElementVNode("div", {
              class: "tab-pane fade",
              id: "code-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "code-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
                "data-clipboard-target": "#basicAlertsCode"
              }, " Copy "),
              _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
                _createTextVNode(""),
                _createElementVNode("code", {
                  class: "language-markup",
                  id: "basicAlertsCode"
                }, [
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "<div class=\"form-group mb-0\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "     <label class=\"label\">Time Picker</label>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "     <div class=\"form-group position-relative\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "         <input type=\"time\" class=\"form-control h-55 text-dark ps-5 h-58\" style=\"left: 15px;\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "         <i class=\"ri-time-line position-absolute top-50 translate-middle-y fs-20 text-gray-light ps-20\"></i>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "   </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "</div>"),
                  _createTextVNode("\n")
                ]),
                _createTextVNode("\n")
              ])
            ])
          ])
        ])
      ])
    ], -1),
    _createElementVNode("div", { class: "col-lg-6" }, [
      _createElementVNode("div", { class: "card bg-white border-0 rounded-3 mb-4" }, [
        _createElementVNode("div", { class: "card-body p-4" }, [
          _createElementVNode("h4", { class: "fs-18 mb-4" }, "Date Picker"),
          _createElementVNode("ul", {
            class: "nav nav-tabs mb-4",
            id: "myTab2",
            role: "tablist"
          }, [
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link active",
                id: "preview2-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#preview2-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "preview2-tab-pane",
                "aria-selected": "true"
              }, " Preview ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link",
                id: "code2-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#code2-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "code2-tab-pane",
                "aria-selected": "false"
              }, " Code ")
            ])
          ]),
          _createElementVNode("div", {
            class: "tab-content",
            id: "myTabContent2"
          }, [
            _createElementVNode("div", {
              class: "tab-pane fade show active",
              id: "preview2-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "preview2-tab",
              tabindex: "0"
            }, [
              _createElementVNode("div", { class: "form-group mb-0" }, [
                _createElementVNode("label", { class: "label" }, "Date Picker"),
                _createElementVNode("div", { class: "form-group position-relative" }, [
                  _createElementVNode("input", {
                    type: "date",
                    class: "form-control h-55 text-dark ps-5 h-58"
                  }),
                  _createElementVNode("i", { class: "ri-calendar-line position-absolute top-50 translate-middle-y fs-20 text-gray-light ps-20" })
                ])
              ])
            ]),
            _createElementVNode("div", {
              class: "tab-pane fade",
              id: "code2-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "code2-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
                "data-clipboard-target": "#basicAlertsCode2"
              }, " Copy "),
              _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
                _createTextVNode(""),
                _createElementVNode("code", {
                  class: "language-markup",
                  id: "basicAlertsCode2"
                }, [
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "<div class=\"form-group mb-0\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "   <label class=\"label\">Date Picker</label>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "     <div class=\"form-group position-relative\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "         <input type=\"date\" class=\"form-control h-55 text-dark ps-5 h-58\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "         <i class=\"ri-calendar-line position-absolute top-50 translate-middle-y fs-20 text-gray-light ps-20\"></i>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "     </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "</div>"),
                  _createTextVNode("\n")
                ]),
                _createTextVNode("\n")
              ])
            ])
          ])
        ])
      ])
    ], -1)
  ])))
}